import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/add_task.css";
import InputMask from "react-input-mask";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import AddClientSygnPopup from "./add_client_sygn_popup.js";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const AddTask = (props) => {
  const [date, setDate] = useState(
    props.mode === "edit"
      ? new Date(props.taskData.start_date).getFullYear() +
          "-" +
          (new Date(props.taskData.start_date).getMonth() + 1 < 10
            ? "0" + (new Date(props.taskData.start_date).getMonth() + 1)
            : new Date(props.taskData.start_date).getMonth() + 1) +
          "-" +
          (new Date(props.taskData.start_date).getDate() < 10
            ? "0" + new Date(props.taskData.start_date).getDate()
            : new Date(props.taskData.start_date).getDate())
      : ""
  );
  const [final_date, setFinalDate] = useState(
    props.mode === "edit"
      ? new Date(props.taskData.final_date).getFullYear() +
          "-" +
          (new Date(props.taskData.final_date).getMonth() + 1 < 10
            ? "0" + (new Date(props.taskData.final_date).getMonth() + 1)
            : new Date(props.taskData.final_date).getMonth() + 1) +
          "-" +
          (new Date(props.taskData.final_date).getDate() < 10
            ? "0" + new Date(props.taskData.final_date).getDate()
            : new Date(props.taskData.final_date).getDate())
      : ""
  );
  const [final_date_ori, setFinalDate_ori] = useState(
    props.mode === "edit" ? props.taskData.final_date : ""
  );
  const [task, setTask] = useState(
    props.mode === "edit" ? props.taskData.task : ""
  );
  const [bank, setBank] = useState(
    props.mode === "edit" ? props.taskData.bank : ""
  );
  const [court, setCourt] = useState(
    props.mode === "edit" ? props.taskData.court : ""
  );
  const [sygnA, setSygnA] = useState(
    props.mode === "edit" ? props.taskData.sygn : ""
  );
  const [name, setName] = useState(
    props.mode === "edit" ? props.taskData.client_name : ""
  );
  const [tType, setTType] = useState(
    props.mode === "edit" ? props.taskData.type : "SĄDOWE"
  );
  const [clientsE, setClientsE] = useState(
    props.mode === "edit" ? props.clients : []
  );
  const [responsible, setResponsible] = useState(
    props.mode === "edit" ? props.taskData.responsible : ""
  );
  const [note, setNote] = useState(
    props.mode === "edit"
      ? props.taskData.note_task === "undefined"
        ? ""
        : props.taskData.note_task
      : ""
  );
  const [isCyclic, setIsCyclic] = useState(false);
  const [cyclePeriod, setCyclePeriod] = useState("7");
  const [client, setClient] = useState(
    props.mode === "main" ? "" : props.client
  );
  const [clientId, setClientId] = useState("");
  const [taskMode, setTaskMode] = useState("c");
  const [uploadFiles, setUploadFiles] = useState("");
  const [uploadFilesArray, setUploadFilesArray] = useState([]);
  const [uploadFilesNamesArray, setUploadFilesNamesArray] = useState([]);
  const [uploadFilesNamesArrayChanged, setUploadFilesNamesArrayChanged] =
    useState([]);
  const [inputs, setInputs] = useState({});
  const [fileType, setFileType] = useState("send");
  const [clients, setClients] = useState([]);
  const [clientsSygn, setClientsSygn] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddSygnPopUp, setShowAddSygnPopUp] = useState(false);
  const [courtOri, setCourtOri] = useState(
    props.mode === "edit" ? props.taskData.court : ""
  );
  const [sygnAOri, setSygnAOri] = useState(
    props.mode === "edit" ? props.taskData.sygn : ""
  );
  const [taskTypesOptions, setTaskTypesOptions] = useState([]);
  const [clientsOptions, setClientsOptions] = useState([]);
  const [banksOptions, setBanksOptions] = useState([]);
  const [courtOptions, setCourtOptions] = useState([]);
  const [lawyersOptions, setLawyersOptions] = useState([]);
  const [closedTask, setClosedTask] = useState(false);
  const [nTeam, setNTeam] = useState(props.team === 0 ? "1" : props.team);
  const [holidays, setHolidays] = useState([]);
  const [freeDays, setFreeDays] = useState([]);
  const [addF, setAddF] = useState(false);
  const [groups, setGroups] = useState([]);
  const [group, setGroup] = useState("");
  const [respOption, setRespOption] = useState("person");
  const [groupOptions, setGroupOptions] = useState([]);
  const [cycle, setCycle] = useState("");
  const [taskTypes, setTaskTypes] = useState([]);

  const makeid = (length) => {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  const fetchClients = async () => {
    if (props.place === "client" || props.mode === "edit") {
      setCourtOri(props.client.aCourt);
      setSygnAOri(props.client.aSygn);
      setCourt(props.client.aCourt);
      setSygnA(props.client.aSygn);
      fetchHolidays();
      return;
    } else {
      var body = {
        team: props.team,
      };

      await fetch("https://apidevkppp.ftpeople.pl/getClientsListAddDate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {
          data = getAllowedClients(data).filter((el) => el.arch === "0");
          setClients(data);
          setClientsOptions(createClientsOptions(data));
          if (props.place === "client") {
            setCourtOri(
              data.filter((el) => el.id === props.client.id)[0].aCourt ===
                "brak danych"
                ? ""
                : data.filter((el) => el.id === props.client.id)[0].aCourt
            );
            setSygnAOri(
              data.filter((el) => el.id === props.client.id)[0].aSygn ===
                "brak danych"
                ? ""
                : data.filter((el) => el.id === props.client.id)[0].aSygn
            );
            setCourt(
              data.filter((el) => el.id === props.client.id)[0].aCourt ===
                "brak danych"
                ? ""
                : data.filter((el) => el.id === props.client.id)[0].aCourt
            );
            setSygnA(
              data.filter((el) => el.id === props.client.id)[0].aSygn ===
                "brak danych"
                ? ""
                : data.filter((el) => el.id === props.client.id)[0].aSygn
            );
          }
          fetchHolidays();
        })
        .catch((error) => {});
    }
  };

  const fetchClientsAll = async () => {
    if (props.place === "client" || props.mode === "edit") {
      setCourtOri(props.client.aCourt);
      setSygnAOri(props.client.aSygn);
      setCourt(props.client.aCourt);
      setSygnA(props.client.aSygn);
      fetchHolidays();
      return;
    } else {
      var body = {
        team: props.team,
      };

      await fetch("https://apidevkppp.ftpeople.pl/getClientsListAddDateAll", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {
          data = getAllowedClients(data).filter((el) => el.arch === "0");
          setClients(data);
          setClientsOptions(createClientsOptions(data));
          if (props.place === "client") {
            setCourtOri(
              data.filter((el) => el.id === props.client.id)[0].aCourt ===
                "brak danych"
                ? ""
                : data.filter((el) => el.id === props.client.id)[0].aCourt
            );
            setSygnAOri(
              data.filter((el) => el.id === props.client.id)[0].aSygn ===
                "brak danych"
                ? ""
                : data.filter((el) => el.id === props.client.id)[0].aSygn
            );
            setCourt(
              data.filter((el) => el.id === props.client.id)[0].aCourt ===
                "brak danych"
                ? ""
                : data.filter((el) => el.id === props.client.id)[0].aCourt
            );
            setSygnA(
              data.filter((el) => el.id === props.client.id)[0].aSygn ===
                "brak danych"
                ? ""
                : data.filter((el) => el.id === props.client.id)[0].aSygn
            );
          }
          fetchHolidays();
        })
        .catch((error) => {});
    }
  };

  const fetchHolidays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidays(data.filter((el) => el.type === "holiday"));
        fetchFreeDays();
      })
      .catch((error) => {});
  };

  const fetchFreeDays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getFreeDays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFreeDays(data);
        fetchGroups();
      })
      .catch((error) => {});
  };

  const fetchGroups = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getTaskLoopGroups", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setGroups(
          data.sort(function (a, b) {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          })
        );
        if (data.length > 0 && group.length === 0) {
          var arr = [];
          data.map((ew) => {
            arr.push({ value: ew.name, label: ew.name });
          });
          setGroupOptions(arr);
          setGroup(
            data.sort(function (a, b) {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }
              return 0;
            })[0].name
          );
        }

        fetchTypes();
      })
      .catch((error) => {});
  };

  const fetchTypes = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTaskTypes", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTaskTypes(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const checkFree = (date) => {
    var blocks = freeDays.filter((el) => el.date === date);

    var bool = false;

    if (blocks.length > 0) {
      bool = true;
    } else {
      bool = false;
    }

    if (new Date(date).getDay() === 0 || new Date(date).getDay() === 6) {
      bool = true;
    }

    return bool;
  };

  const getAllowedClients = (data) => {
    if (props.user.allowedClients === "all") {
      return data;
    } else {
      var allowed = props.user.allowedClients
        .toString()
        .replaceAll(" ", "")
        .split(",");
      var arr = [];
      allowed.map((el) => {
        arr = arr.concat(data.filter((el2) => +el2.id === +el));
      });
      return arr;
    }
  };

  const fetchClientsSygn = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientsSygn", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClientsSygn(data);
        if (props.place === "client") {
          setCourtOri(
            getActualCourtForClientData(props.client.id, data) === "brak danych"
              ? ""
              : getActualCourtForClientData(props.client.id, data)
          );
          setSygnAOri(
            getActualSygnForClientData(props.client.id, data) === "brak danych"
              ? ""
              : getActualSygnForClientData(props.client.id, data)
          );
          setCourt(
            getActualCourtForClientData(props.client.id, data) === "brak danych"
              ? ""
              : getActualCourtForClientData(props.client.id, data)
          );
          setSygnA(
            getActualSygnForClientData(props.client.id, data) === "brak danych"
              ? ""
              : getActualSygnForClientData(props.client.id, data)
          );
        }
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getActualCourtForClientData = (clientId, data) => {
    var sygns = data.filter((el) => +el.clientId === +clientId);
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });

    return sygns.length > 0
      ? sygns[0].court !== ""
        ? sygns[0].court
        : "brak danych"
      : "brak danych";
  };

  const getActualSygnForClientData = (clientId, data) => {
    var sygns = data.filter((el) => +el.clientId === +clientId);
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    return sygns.length > 0
      ? sygns[0].sygn.length > 4
        ? sygns[0].sygn
        : "brak danych"
      : "brak danych";
  };

  const getData = () => {
    setLoading(true);
    if (props.team === 0) {
      fetchClientsAll();
    } else {
      fetchClients();
    }

    setTaskTypesOptions(createTaskTypesOptions());
    setCourtOptions(createCourtOptions());
    setBanksOptions(createBankOptions());
    setLawyersOptions(createLawyersOptions());
    setCycle(makeid(5));
  };

  useEffect(() => {
    getData();
  }, []);

  const changeFiles = (e) => {
    setUploadFiles([]);
    setUploadFilesArray([]);
    setUploadFilesNamesArray([]);

    var check = false;

    Array.from(e.target.files).map((file) => {
      if (file.size > 41943040) {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "plik przekracza 40MB",
        });
        check = true;
      }
    });

    if (check) {
      return;
    }

    setUploadFiles(e.target.files);
    setUploadFilesArray(Array.from(e.target.files));
    var arr = [];
    Array.from(e.target.files).map((el, index) => {
      arr.push({ id: index, name: el.name });
    });
    setUploadFilesNamesArray(arr);
  };

  const handleAddClient = (e) => {
    var check = e.target.value.split(" ").length > 1;
    if (check) {
      if (e.target.value === "") {
        return;
      } else {
        clientsE.push({ id: Math.random() * 100, name: e.target.value });
        setName("");
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Imię i nazwisko niepoprawne",
      });
    }
  };

  const handleDeleteClient = (e) => {
    var newArray = clientsE.filter((el) => el.id !== +e.target.value);
    setClientsE(newArray);
  };

  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };

  const getClientName = () => {
    var client = "";
    clientsE.map((el) => {
      if (client === "") {
        client += el.name;
      } else {
        client += " , " + el.name;
      }
    });

    return client;
  };

  const handleDateChange = (e) => {
    setDate(e.target.value);
  };

  const handleFinalDateChange = (e) => {
    setFinalDate(e.target.value);
  };

  const handleTaskChange = (e) => {
    setTask(e.value);
  };

  const handleIsCyclicChange = (e) => {
    setIsCyclic(e.target.checked);
  };

  const handleIsClosedChange = (e) => {
    setClosedTask(e.target.checked);
    if (e.target.checked) {
      setFinalDate(
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1 < 10
            ? "0" + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1) +
          "-" +
          (new Date().getDate() < 10
            ? "0" + new Date().getDate()
            : new Date().getDate())
      );
      setDate(
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1 < 10
            ? "0" + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1) +
          "-" +
          (new Date().getDate() < 10
            ? "0" + new Date().getDate()
            : new Date().getDate())
      );
    } else {
      setFinalDate("");
      setDate("");
    }
  };

  const handleBankChange = (e) => {
    setBank(e.value);
  };

  const handleCourtChange = (e) => {
    setCourt(e.value);
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleCyclePeriodChange = (e) => {
    setCyclePeriod(e.target.value);
  };

  const handleTTypeChange = (e) => {
    setTType(e.target.value);
  };

  const handleSygnChange = (e) => {
    setSygnA(e.target.value);
  };

  const handleResponsibleChange = (e) => {
    setResponsible(e.value);
  };

  const addClientSygn = async () => {
    if (court !== courtOri || sygnA !== sygnAOri) {
      var addX = false;
      MySwal.fire({
        title: "Czy dodawana sygnatura jest sygnaturą poboczną?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Tak",
        denyButtonText: `Nie`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          addX = true;

          var body = {
            clientId: props.place === "client" ? props.client.id : clientId,
            sygn: sygnA,
            date:
              new Date().getFullYear() +
              "-" +
              (new Date().getMonth() + 1 < 10
                ? "0" + (new Date().getMonth() + 1)
                : new Date().getMonth() + 1) +
              "-" +
              (new Date().getDate() < 10
                ? "0" + new Date().getDate()
                : new Date().getDate()) +
              " " +
              new Date().getHours() +
              ":" +
              new Date().getMinutes() +
              ":" +
              new Date().getSeconds(),
            court: court,
            who: props.user.name,
            add: addX,
          };

          await fetch("https://apidevkppp.ftpeople.pl/addSygnClient", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.json())
            .then((data) => {})
            .catch((error) => {});
        } else if (result.isDenied) {
          addX = false;
          if (court !== courtOri || sygnA !== sygnAOri) {
            var body = {
              clientId: props.place === "client" ? props.client.id : clientId,
              sygn: sygnA,
              date:
                new Date().getFullYear() +
                "-" +
                (new Date().getMonth() + 1 < 10
                  ? "0" + (new Date().getMonth() + 1)
                  : new Date().getMonth() + 1) +
                "-" +
                (new Date().getDate() < 10
                  ? "0" + new Date().getDate()
                  : new Date().getDate()) +
                " " +
                new Date().getHours() +
                ":" +
                new Date().getMinutes() +
                ":" +
                new Date().getSeconds(),
              court: court,
              who: props.user.name,
              add: addX,
            };

            await fetch("https://apidevkppp.ftpeople.pl/addSygnClient", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.json())
              .then((data) => {
                MySwal.fire({
                  icon: "success",
                  title: "Dodano",
                  text: "nowe zadanie",
                }).then((result) => {
                  props.close();
                });
              })
              .catch((error) => {});
          } else {
            MySwal.fire({
              icon: "success",
              title: "Dodano",
              text: "nowe zadanie",
            }).then((result) => {
              props.close();
            });
          }
        }
      });
    }
  };

  const getLawyerName = (initials) => {
    var name = props.usersData.filter((el) => el.initials === initials);
    return name.length > 0 ? name[0].name : "brak danych";
  };

  const addDay = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 49));
    return retDate;
  };

  const addWeeksTwo = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 14));
    return retDate;
  };

  const addTaskAccept = () => {
    if (!checkFree(final_date)) {
      if (respOption === "person") {
        if (!checkHoliday()) {
          addTask();
        } else {
          MySwal.fire({
            title:
              "Osoba, której chcesz przypisać zadanie jest w tym czasie na urlopie. Czy nadal chcesz przypisać?",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Tak",
            denyButtonText: `Nie`,
          }).then(async (result) => {
            if (result.isConfirmed) {
              addTask();
            } else if (result.isDenied) {
              return;
            }
          });
        }
      } else {
        addTaskGroup();
      }
    } else {
      MySwal.fire({
        title:
          "W dniu wykonania zadania przypada dzień wolny. Czy nadal chcesz dodać zadanie?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Tak",
        denyButtonText: `Nie`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (respOption === "person") {
            addTask();
          } else {
            addTaskGroup();
          }
        } else if (result.isDenied) {
          return;
        }
      });
    }
  };

  const addTask = async (e) => {
    setLoading(true);

    if (
      task ===
        "Sędzia SA-teoria salda-kontakt z klientem celem namówienia do ugody" ||
      task ===
        "Sędzia SO-teoria salda-kontakt z klientem celem namówienia do ugody"
    ) {
      var bodyX = {
        clientId: client.id,
        field: "sts",
        value: "TAK",
      };

      fetch("https://apidevkppp.ftpeople.pl/updateFieldClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(bodyX),
      })
        .then((response) => response.text())
        .then((responseJson) => {});
    }

    if (
      task ===
      "Sędzia SO-uwzględnia potrącenie i znosi KZP-kontakt z klientem celem namówienia do ugody"
    ) {
      var bodyX = {
        clientId: client.id,
        field: "sup",
        value: "TAK",
      };

      fetch("https://apidevkppp.ftpeople.pl/updateFieldClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(bodyX),
      })
        .then((response) => response.text())
        .then((responseJson) => {});
    }

    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var cycleId = new Date().valueOf();
    if (new Date(date) <= new Date()) {
      if (new Date(date) <= new Date(final_date)) {
        if (
          new Date(final_date) >=
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate()
          )
        ) {
          if (true) {
            if (validateForm()) {
              if (
                task === "Rozważ cofnięcie pozwu - klient otrzymał potrącenie"
              ) {
                var bodyX = {
                  id: props.client.id,
                  date: "TAK",
                };

                fetch("https://apidevkppp.ftpeople.pl/updatePotrCl", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: secretKey,
                  },
                  body: JSON.stringify(bodyX),
                })
                  .then((response) => response.text())
                  .then((responseJson) => {});
              }

              var body = {
                responsible:
                  props.user.role === "admin" ? responsible : props.user.name,
                start_date: date,
                final_date: final_date,
                bank: taskMode === "c" ? client.bank : bank,
                sygn:
                  taskMode === "c" ? (tType === "SĄDOWE" ? sygnA : "") : sygnA,
                client_name:
                  taskMode === "c" ? client.petitioner : getClientName(),
                task: task,
                date_added: date_added,
                user_added: props.user.name,
                status: closedTask
                  ? "WYKONANE"
                  : props.user.role === "admin"
                  ? responsible === ""
                    ? "ZLECONE"
                    : "ZLECONE"
                  : "ZLECONE",
                court:
                  taskMode === "c" ? (tType === "SĄDOWE" ? court : "") : court,
                type: tType,
                addRole: props.userRole,
                readed: "no",
                cycleId: isCyclic ? cycleId : "",
                clientId: taskMode === "c" ? client.id : "",
                task_conn: taskMode,
                team: taskMode === "n" ? nTeam : client.team,
                note: note,
              };

              await fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: secretKey,
                },
                body: JSON.stringify(body),
              })
                .then((response) => response.text())
                .then(async (data) => {
                  var length = uploadFilesArray.length;
                  var progr = 0;
                  if (length > 0) {
                    uploadFilesArray.map(async (file) => {
                      let formData = new FormData();
                      formData.append("file", file);
                      formData.append("type", "task");
                      formData.append(
                        "clientId",
                        taskMode === "c" ? client.id : ""
                      );
                      formData.append("taskId", data);
                      formData.append("user", props.user.name);

                      await fetch("https://apidevkppp.ftpeople.pl/uploadFile", {
                        method: "POST",
                        body: formData,
                      })
                        .then((response) => {
                          return response.text();
                        })
                        .then((responseJson) => {
                          ++progr;
                          MySwal.fire({
                            icon: "success",
                            title: "Wysłano plik: " + progr + "/" + length,
                            text: "",
                          }).then(async (result) => {
                            if (progr === length) {
                              if (
                                taskMode === "c" &&
                                task === "Apelacja" &&
                                closedTask
                              ) {
                                var body = {
                                  status:
                                    "przegrana w I instancji - wnieśliśmy apelację",
                                  status_note: "",
                                  id: client.id,
                                };

                                fetch(
                                  "https://apidevkppp.ftpeople.pl/setClientStatus",
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: secretKey,
                                    },
                                    body: JSON.stringify(body),
                                  }
                                )
                                  .then((response) => response.json())
                                  .then((data) => {
                                    return;
                                  })
                                  .catch((error) => {});
                              }

                              if (
                                taskMode === "c" &&
                                task === "Odpowiedź na apelację" &&
                                closedTask
                              ) {
                                var body = {
                                  status:
                                    "wygrana w I instancji - wpłynęła apelacja",
                                  status_note: "",
                                  id: client.id,
                                };

                                fetch(
                                  "https://apidevkppp.ftpeople.pl/setClientStatus",
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: secretKey,
                                    },
                                    body: JSON.stringify(body),
                                  }
                                )
                                  .then((response) => response.json())
                                  .then((data) => {
                                    return;
                                  })
                                  .catch((error) => {});
                              }

                              if (
                                taskMode === "c" &&
                                task === "Odpowiedź na wezwanie do zapłaty" &&
                                closedTask
                              ) {
                                var date_added3 =
                                  new Date().getFullYear() +
                                  "-" +
                                  (new Date().getMonth() + 1) +
                                  "-" +
                                  new Date().getDate() +
                                  " " +
                                  new Date().getHours() +
                                  ":" +
                                  new Date().getMinutes();
                                var date_start3 =
                                  new Date().getFullYear() +
                                  "-" +
                                  (new Date().getMonth() + 1) +
                                  "-" +
                                  new Date().getDate();
                                var dateFinal3 = new Date();

                                if (addWeeksTwo(new Date(date)) < new Date()) {
                                  var newFinalDate3 = new Date(
                                    new Date().setDate(new Date().getDate() + 1)
                                  );
                                } else {
                                  var newFinalDate3 = addWeeksTwo(
                                    new Date(date)
                                  );
                                }

                                if (newFinalDate3.getDay() === 0) {
                                  newFinalDate3 = new Date(
                                    newFinalDate3.setDate(
                                      newFinalDate3.getDate() + 1
                                    )
                                  );
                                }
                                if (newFinalDate3.getDay() === 6) {
                                  newFinalDate3 = new Date(
                                    newFinalDate3.setDate(
                                      newFinalDate3.getDate() + 2
                                    )
                                  );
                                }
                                dateFinal3 =
                                  newFinalDate3.getFullYear() +
                                  "-" +
                                  (newFinalDate3.getMonth() + 1) +
                                  "-" +
                                  newFinalDate3.getDate();

                                var body2 = {
                                  start_date: date_start3,
                                  final_date: dateFinal3,
                                  bank: client.bank,
                                  sygn: client.aSygn,
                                  responsible: responsible,
                                  client_name: client.petitioner,
                                  task: "Sprawdzenie czy klient wysłał podpisaną odpowiedź na wezwanie i potw. nadania oraz należy dodać dokumenty do Workflow",
                                  date_added: date_added3,
                                  user_added: "",
                                  status: "ZLECONE",
                                  court: client.aCourt,
                                  type: "POZASĄDOWE",
                                  readed: "no",
                                  clientId: client.id,
                                  task_conn: "c",
                                  team: taskMode === "n" ? nTeam : client.team,
                                };

                                await fetch(
                                  "https://apidevkppp.ftpeople.pl/insertTask",
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: secretKey,
                                    },
                                    body: JSON.stringify(body2),
                                  }
                                )
                                  .then((response) => response.json())
                                  .then((data) => {})
                                  .catch((error) => {});
                              }

                              if (
                                taskMode === "c" &&
                                (task === "Wezwanie do zapłaty" ||
                                  (client.type === "sankcja kredytu darmowego"
                                    ? task ===
                                      "Wezwanie do zapłaty z oświadczeniem"
                                    : false))
                              ) {
                                var body = {
                                  id: client.id,
                                  data_zasw: date,
                                };

                                fetch(
                                  "https://apidevkppp.ftpeople.pl/addDZClient",
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: secretKey,
                                    },
                                    body: JSON.stringify(body),
                                  }
                                )
                                  .then((response) => response.json())
                                  .then((data) => {
                                    return;
                                  })
                                  .catch((error) => {});

                                var date_added3 =
                                  new Date().getFullYear() +
                                  "-" +
                                  (new Date().getMonth() + 1) +
                                  "-" +
                                  new Date().getDate() +
                                  " " +
                                  new Date().getHours() +
                                  ":" +
                                  new Date().getMinutes();
                                var date_start3 =
                                  new Date().getFullYear() +
                                  "-" +
                                  (new Date().getMonth() + 1) +
                                  "-" +
                                  new Date().getDate();
                                var dateFinal3 = new Date();

                                if (addDay(new Date(date)) < new Date()) {
                                  var newFinalDate3 = new Date(
                                    new Date().setDate(new Date().getDate() + 1)
                                  );
                                } else {
                                  var newFinalDate3 = addDay(new Date(date));
                                }

                                if (newFinalDate3.getDay() === 0) {
                                  newFinalDate3 = new Date(
                                    newFinalDate3.setDate(
                                      newFinalDate3.getDate() + 1
                                    )
                                  );
                                }
                                if (newFinalDate3.getDay() === 6) {
                                  newFinalDate3 = new Date(
                                    newFinalDate3.setDate(
                                      newFinalDate3.getDate() + 2
                                    )
                                  );
                                }
                                dateFinal3 =
                                  newFinalDate3.getFullYear() +
                                  "-" +
                                  (newFinalDate3.getMonth() + 1) +
                                  "-" +
                                  newFinalDate3.getDate();

                                var body2 = {
                                  start_date: date_start3,
                                  final_date: dateFinal3,
                                  bank: client.bank,
                                  sygn: client.aSygn,
                                  responsible: getLawyerName(
                                    client.client_owner
                                  ),
                                  client_name: client.petitioner,
                                  task: "Za 7 dni upływa terminu do wysłania pozwu",
                                  date_added: date_added3,
                                  user_added: "",
                                  status: "ZLECONE",
                                  court: client.aCourt,
                                  type: "POZASĄDOWE",
                                  readed: "no",
                                  clientId: client.id,
                                  task_conn: "c",
                                  team: taskMode === "n" ? nTeam : client.team,
                                };

                                await fetch(
                                  "https://apidevkppp.ftpeople.pl/insertTask",
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: secretKey,
                                    },
                                    body: JSON.stringify(body2),
                                  }
                                )
                                  .then((response) => response.json())
                                  .then((data) => {})
                                  .catch((error) => {});

                                var body3 = {
                                  id: client.id,
                                  praw_wezw:
                                    props.user.role === "admin"
                                      ? responsible
                                      : props.user.name,
                                };

                                fetch(
                                  "https://apidevkppp.ftpeople.pl/addPWClient",
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: secretKey,
                                    },
                                    body: JSON.stringify(body3),
                                  }
                                )
                                  .then((response) => response.json())
                                  .then((data) => {
                                    return;
                                  })
                                  .catch((error) => {});

                                var body4 = {
                                  status:
                                    "mamy dokumenty - wezwanie do wysłania",
                                  status_note: "",
                                  id: client.id,
                                };

                                fetch(
                                  "https://apidevkppp.ftpeople.pl/setClientStatus",
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: secretKey,
                                    },
                                    body: JSON.stringify(body4),
                                  }
                                )
                                  .then((response) => response.json())
                                  .then((data) => {})
                                  .catch((error) => {});
                              }

                              if (
                                taskMode === "c" &&
                                task === "Sporządzenie pozwu"
                              ) {
                                var body3 = {
                                  id: client.id,
                                  praw_pozew:
                                    props.user.role === "admin"
                                      ? responsible
                                      : props.user.name,
                                };

                                fetch(
                                  "https://apidevkppp.ftpeople.pl/addPPClient",
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: secretKey,
                                    },
                                    body: JSON.stringify(body3),
                                  }
                                )
                                  .then((response) => response.json())
                                  .then((data) => {
                                    return;
                                  })
                                  .catch((error) => {});
                              }

                              if (isCyclic) {
                                var finalDate = new Date(final_date).setDate(
                                  new Date(final_date).getDate() + 90
                                );
                                switch (cyclePeriod) {
                                  case "7":
                                    finalDate = new Date(final_date).setDate(
                                      new Date(final_date).getDate() + 90
                                    );
                                    break;
                                  case "14":
                                    finalDate = new Date(final_date).setDate(
                                      new Date(final_date).getDate() + 90
                                    );
                                    break;
                                  case "28":
                                    finalDate = new Date(final_date).setDate(
                                      new Date(final_date).getDate() + 180
                                    );
                                    break;
                                  case "90":
                                    finalDate = new Date(final_date).setDate(
                                      new Date(final_date).getDate() + 365
                                    );
                                    break;
                                  default:
                                    break;
                                }

                                var cycle = +cyclePeriod;
                                var startDate = new Date(final_date);
                                while (
                                  new Date(startDate) <= new Date(finalDate)
                                ) {
                                  startDate = new Date(
                                    startDate.setDate(
                                      startDate.getDate() + cycle
                                    )
                                  );
                                  if (startDate.getDay() === 0) {
                                    startDate = new Date(
                                      startDate.setDate(startDate.getDate() + 1)
                                    );
                                  }
                                  if (startDate.getDay() === 6) {
                                    startDate = new Date(
                                      startDate.setDate(startDate.getDate() + 2)
                                    );
                                  }

                                  var body = {
                                    responsible:
                                      props.user.role === "admin"
                                        ? responsible
                                        : props.user.name,
                                    start_date: date,
                                    final_date:
                                      startDate.getFullYear() +
                                      "-" +
                                      (startDate.getMonth() + 1) +
                                      "-" +
                                      startDate.getDate(),
                                    bank: taskMode === "c" ? client.bank : bank,
                                    sygn:
                                      taskMode === "c"
                                        ? tType === "SĄDOWE"
                                          ? sygnA
                                          : ""
                                        : sygnA,
                                    client_name:
                                      taskMode === "c"
                                        ? client.petitioner
                                        : getClientName(),
                                    task: task,
                                    date_added: date_added,
                                    user_added: props.user.name,
                                    status: closedTask
                                      ? "WYKONANE"
                                      : props.user.role === "admin"
                                      ? responsible === ""
                                        ? "ZLECONE"
                                        : "ZLECONE"
                                      : "ZLECONE",
                                    court:
                                      taskMode === "c"
                                        ? tType === "SĄDOWE"
                                          ? court
                                          : ""
                                        : court,
                                    type: tType,
                                    addRole: props.userRole,
                                    readed: "no",
                                    cycleId: cycleId,
                                    clientId: taskMode === "c" ? client.id : "",
                                    task_conn: taskMode,
                                    team:
                                      taskMode === "n" ? nTeam : client.team,
                                    note: note,
                                  };

                                  await fetch(
                                    "https://apidevkppp.ftpeople.pl/insertTaskFull",
                                    {
                                      method: "POST",
                                      headers: {
                                        "Content-Type": "application/json",
                                        Authorization: secretKey,
                                      },
                                      body: JSON.stringify(body),
                                    }
                                  )
                                    .then((response) => response.json())
                                    .then((data) => {})
                                    .catch((error) => {});
                                }
                              }
                              props.handleOptionChangeClose("calendar");
                              if (
                                taskMode === "c" ||
                                props.place === "client"
                              ) {
                                addClientSygn();
                              } else {
                                MySwal.fire({
                                  icon: "success",
                                  title: "Dodano",
                                  text: "nowe zadanie",
                                }).then((result) => {
                                  props.close();
                                });
                              }
                            }
                          });
                        });
                    });
                  } else {
                    if (taskMode === "c" && task === "Apelacja" && closedTask) {
                      var body = {
                        status: "przegrana w I instancji - wnieśliśmy apelację",
                        status_note: "",
                        id: client.id,
                      };

                      fetch("https://apidevkppp.ftpeople.pl/setClientStatus", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body),
                      })
                        .then((response) => response.json())
                        .then((data) => {
                          return;
                        })
                        .catch((error) => {});
                    }

                    if (
                      taskMode === "c" &&
                      task === "Odpowiedź na apelację" &&
                      closedTask
                    ) {
                      var body = {
                        status: "wygrana w I instancji - wpłynęła apelacja",
                        status_note: "",
                        id: client.id,
                      };

                      fetch("https://apidevkppp.ftpeople.pl/setClientStatus", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body),
                      })
                        .then((response) => response.json())
                        .then((data) => {
                          return;
                        })
                        .catch((error) => {});
                    }

                    if (
                      taskMode === "c" &&
                      task === "Odpowiedź na wezwanie do zapłaty" &&
                      closedTask
                    ) {
                      var date_added3 =
                        new Date().getFullYear() +
                        "-" +
                        (new Date().getMonth() + 1) +
                        "-" +
                        new Date().getDate() +
                        " " +
                        new Date().getHours() +
                        ":" +
                        new Date().getMinutes();
                      var date_start3 =
                        new Date().getFullYear() +
                        "-" +
                        (new Date().getMonth() + 1) +
                        "-" +
                        new Date().getDate();
                      var dateFinal3 = new Date();

                      if (addWeeksTwo(new Date(date)) < new Date()) {
                        var newFinalDate3 = new Date(
                          new Date().setDate(new Date().getDate() + 1)
                        );
                      } else {
                        var newFinalDate3 = addWeeksTwo(new Date(date));
                      }

                      if (newFinalDate3.getDay() === 0) {
                        newFinalDate3 = new Date(
                          newFinalDate3.setDate(newFinalDate3.getDate() + 1)
                        );
                      }
                      if (newFinalDate3.getDay() === 6) {
                        newFinalDate3 = new Date(
                          newFinalDate3.setDate(newFinalDate3.getDate() + 2)
                        );
                      }
                      dateFinal3 =
                        newFinalDate3.getFullYear() +
                        "-" +
                        (newFinalDate3.getMonth() + 1) +
                        "-" +
                        newFinalDate3.getDate();

                      var body2 = {
                        start_date: date_start3,
                        final_date: dateFinal3,
                        bank: client.bank,
                        sygn: client.aSygn,
                        responsible: responsible,
                        client_name: client.petitioner,
                        task: "Sprawdzenie czy klient wysłał podpisaną odpowiedź na wezwanie i potw. nadania oraz należy dodać dokumenty do Workflow",
                        date_added: date_added3,
                        user_added: "",
                        status: "ZLECONE",
                        court: client.aCourt,
                        type: "POZASĄDOWE",
                        readed: "no",
                        clientId: client.id,
                        task_conn: "c",
                        team: taskMode === "n" ? nTeam : client.team,
                      };

                      await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body2),
                      })
                        .then((response) => response.json())
                        .then((data) => {})
                        .catch((error) => {});
                    }

                    if (
                      taskMode === "c" &&
                      (task === "Wezwanie do zapłaty" ||
                        (client.type === "sankcja kredytu darmowego"
                          ? task === "Wezwanie do zapłaty z oświadczeniem"
                          : false))
                    ) {
                      var body = {
                        id: client.id,
                        data_zasw: date,
                      };

                      fetch("https://apidevkppp.ftpeople.pl/addDZClient", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body),
                      })
                        .then((response) => response.json())
                        .then((data) => {
                          return;
                        })
                        .catch((error) => {});

                      var date_added3 =
                        new Date().getFullYear() +
                        "-" +
                        (new Date().getMonth() + 1) +
                        "-" +
                        new Date().getDate() +
                        " " +
                        new Date().getHours() +
                        ":" +
                        new Date().getMinutes();
                      var date_start3 =
                        new Date().getFullYear() +
                        "-" +
                        (new Date().getMonth() + 1) +
                        "-" +
                        new Date().getDate();
                      var dateFinal3 = new Date();

                      if (addDay(new Date(date)) < new Date()) {
                        var newFinalDate3 = new Date(
                          new Date().setDate(new Date().getDate() + 1)
                        );
                      } else {
                        var newFinalDate3 = addDay(new Date(date));
                      }

                      if (newFinalDate3.getDay() === 0) {
                        newFinalDate3 = new Date(
                          newFinalDate3.setDate(newFinalDate3.getDate() + 1)
                        );
                      }
                      if (newFinalDate3.getDay() === 6) {
                        newFinalDate3 = new Date(
                          newFinalDate3.setDate(newFinalDate3.getDate() + 2)
                        );
                      }
                      dateFinal3 =
                        newFinalDate3.getFullYear() +
                        "-" +
                        (newFinalDate3.getMonth() + 1) +
                        "-" +
                        newFinalDate3.getDate();

                      var body2 = {
                        start_date: date_start3,
                        final_date: dateFinal3,
                        bank: client.bank,
                        sygn: client.aSygn,
                        responsible: getLawyerName(client.client_owner),
                        client_name: client.petitioner,
                        task: "Za 7 dni upływa terminu do wysłania pozwu",
                        date_added: date_added3,
                        user_added: "",
                        status: "ZLECONE",
                        court: client.aCourt,
                        type: "POZASĄDOWE",
                        readed: "no",
                        clientId: client.id,
                        task_conn: "c",
                        team: taskMode === "n" ? nTeam : client.team,
                      };

                      await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body2),
                      })
                        .then((response) => response.json())
                        .then((data) => {})
                        .catch((error) => {});

                      var body3 = {
                        id: client.id,
                        praw_wezw:
                          props.user.role === "admin"
                            ? responsible
                            : props.user.name,
                      };

                      fetch("https://apidevkppp.ftpeople.pl/addPWClient", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body3),
                      })
                        .then((response) => response.json())
                        .then((data) => {
                          return;
                        })
                        .catch((error) => {});

                      var body4 = {
                        status: "mamy dokumenty - wezwanie do wysłania",
                        status_note: "",
                        id: client.id,
                      };

                      fetch("https://apidevkppp.ftpeople.pl/setClientStatus", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body4),
                      })
                        .then((response) => response.json())
                        .then((data) => {})
                        .catch((error) => {});
                    }

                    if (taskMode === "c" && task === "Sporządzenie pozwu") {
                      var body3 = {
                        id: client.id,
                        praw_pozew:
                          props.user.role === "admin"
                            ? responsible
                            : props.user.name,
                      };

                      fetch("https://apidevkppp.ftpeople.pl/addPPClient", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body3),
                      })
                        .then((response) => response.json())
                        .then((data) => {
                          return;
                        })
                        .catch((error) => {});
                    }

                    if (isCyclic) {
                      var finalDate = new Date(final_date).setDate(
                        new Date(final_date).getDate() + 90
                      );
                      switch (cyclePeriod) {
                        case "7":
                          finalDate = new Date(final_date).setDate(
                            new Date(final_date).getDate() + 90
                          );
                          break;
                        case "14":
                          finalDate = new Date(final_date).setDate(
                            new Date(final_date).getDate() + 90
                          );
                          break;
                        case "28":
                          finalDate = new Date(final_date).setDate(
                            new Date(final_date).getDate() + 180
                          );
                          break;
                        case "90":
                          finalDate = new Date(final_date).setDate(
                            new Date(final_date).getDate() + 365
                          );
                          break;
                        default:
                          break;
                      }

                      var cycle = +cyclePeriod;
                      var startDate = new Date(final_date);
                      while (new Date(startDate) <= new Date(finalDate)) {
                        startDate = new Date(
                          startDate.setDate(startDate.getDate() + cycle)
                        );
                        if (startDate.getDay() === 0) {
                          startDate = new Date(
                            startDate.setDate(startDate.getDate() + 1)
                          );
                        }
                        if (startDate.getDay() === 6) {
                          startDate = new Date(
                            startDate.setDate(startDate.getDate() + 2)
                          );
                        }

                        var body = {
                          responsible:
                            props.user.role === "admin"
                              ? responsible
                              : props.user.name,
                          start_date: date,
                          final_date:
                            startDate.getFullYear() +
                            "-" +
                            (startDate.getMonth() + 1) +
                            "-" +
                            startDate.getDate(),
                          bank: taskMode === "c" ? client.bank : bank,
                          sygn:
                            taskMode === "c"
                              ? tType === "SĄDOWE"
                                ? sygnA
                                : ""
                              : sygnA,
                          client_name:
                            taskMode === "c"
                              ? client.petitioner
                              : getClientName(),
                          task: task,
                          date_added: date_added,
                          user_added: props.user.name,
                          status: closedTask
                            ? "WYKONANE"
                            : props.user.role === "admin"
                            ? responsible === ""
                              ? "ZLECONE"
                              : "ZLECONE"
                            : "ZLECONE",
                          court:
                            taskMode === "c"
                              ? tType === "SĄDOWE"
                                ? court
                                : ""
                              : court,
                          type: tType,
                          addRole: props.userRole,
                          readed: "no",
                          cycleId: cycleId,
                          clientId: taskMode === "c" ? client.id : "",
                          task_conn: taskMode,
                          team: taskMode === "n" ? nTeam : client.team,
                          note: note,
                        };

                        await fetch(
                          "https://apidevkppp.ftpeople.pl/insertTaskFull",
                          {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              Authorization: secretKey,
                            },
                            body: JSON.stringify(body),
                          }
                        )
                          .then((response) => response.json())
                          .then((data) => {})
                          .catch((error) => {});
                      }
                    }
                    props.handleOptionChangeClose("calendar");
                    if (taskMode === "c" || props.place === "client") {
                      addClientSygn();
                    } else {
                      MySwal.fire({
                        icon: "success",
                        title: "Dodano",
                        text: "nowe zadanie",
                      }).then((result) => {
                        props.close();
                      });
                    }
                  }
                })
                .catch((error) => {});
            } else {
              MySwal.fire({
                icon: "error",
                title: "Błąd",
                text: "Wypełnij wymagane pola formularza",
              }).then((result) => {
                setLoading(false);
              });
            }
          } else {
            MySwal.fire({
              icon: "error",
              title: "Błąd",
              text: "Pracownik przebywa w tym czasie na urlopie",
            }).then((result) => {
              setLoading(false);
            });
          }
        } else {
          MySwal.fire({
            icon: "error",
            title: "Błąd",
            text: "Data wykonania zadania musi nastąpić w przyszłości!",
          }).then((result) => {
            setLoading(false);
          });
        }
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Data wprowadzenia zadania musi nastąpić przed datą wykonania!",
        }).then((result) => {
          setLoading(false);
        });
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Data odebrania zadania nie może nastąpić w przyszłości!",
      }).then((result) => {
        setLoading(false);
      });
    }
  };

  const addTaskGroup = async (e) => {
    setLoading(true);
    var groupX = taskTypes.filter((e) => e.name === task)[0].groupX;

    if (
      task ===
        "Sędzia SA-teoria salda-kontakt z klientem celem namówienia do ugody" ||
      task ===
        "Sędzia SO-teoria salda-kontakt z klientem celem namówienia do ugody"
    ) {
      var bodyX = {
        clientId: client.id,
        field: "sts",
        value: "TAK",
      };

      fetch("https://apidevkppp.ftpeople.pl/updateFieldClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(bodyX),
      })
        .then((response) => response.text())
        .then((responseJson) => {});
    }

    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var cycleId = new Date().valueOf();
    if (new Date(date) <= new Date()) {
      if (new Date(date) <= new Date(final_date)) {
        if (
          new Date(final_date) >=
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate()
          )
        ) {
          if (true) {
            if (validateForm()) {
              if (
                task === "Rozważ cofnięcie pozwu - klient otrzymał potrącenie"
              ) {
                var bodyX = {
                  id: props.client.id,
                  date: "TAK",
                };

                fetch("https://apidevkppp.ftpeople.pl/updatePotrCl", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: secretKey,
                  },
                  body: JSON.stringify(bodyX),
                })
                  .then((response) => response.text())
                  .then((responseJson) => {});
              }

              var body = {
                group: groupX,

                cycle: cycle,
                responsible:
                  props.user.role === "admin" ? responsible : props.user.name,
                start_date: date,
                final_date: final_date,
                bank: taskMode === "c" ? client.bank : bank,
                sygn:
                  taskMode === "c" ? (tType === "SĄDOWE" ? sygnA : "") : sygnA,
                client_name:
                  taskMode === "c" ? client.petitioner : getClientName(),
                task: task,
                date_added: date_added,
                user_added: props.user.name,
                status: closedTask
                  ? "WYKONANE"
                  : props.user.role === "admin"
                  ? "ZLECONE"
                  : "ZLECONE",
                court:
                  taskMode === "c" ? (tType === "SĄDOWE" ? court : "") : court,
                type: tType,
                addRole: props.userRole,
                readed: "no",
                cycleId: isCyclic ? cycleId : "",
                clientId: taskMode === "c" ? client.id : "",
                task_conn: taskMode,
                team: taskMode === "n" ? nTeam : client.team,
                note: note,
              };

              await fetch(
                "https://apidevkppp.ftpeople.pl/insertTaskFullGroup",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: secretKey,
                  },
                  body: JSON.stringify(body),
                }
              )
                .then((response) => response.text())
                .then(async (data) => {
                  var length = uploadFilesArray.length;
                  var progr = 0;
                  if (length > 0) {
                    uploadFilesArray.map(async (file) => {
                      let formData = new FormData();
                      formData.append("file", file);
                      formData.append("type", "task");
                      formData.append(
                        "clientId",
                        taskMode === "c" ? client.id : ""
                      );
                      formData.append("taskId", data);
                      formData.append("user", props.user.name);

                      await fetch("https://apidevkppp.ftpeople.pl/uploadFile", {
                        method: "POST",
                        body: formData,
                      })
                        .then((response) => {
                          return response.text();
                        })
                        .then((responseJson) => {
                          ++progr;
                          MySwal.fire({
                            icon: "success",
                            title: "Wysłano plik: " + progr + "/" + length,
                            text: "",
                          }).then(async (result) => {
                            if (progr === length) {
                              if (
                                taskMode === "c" &&
                                task === "Apelacja" &&
                                closedTask
                              ) {
                                var body = {
                                  status:
                                    "przegrana w I instancji - wnieśliśmy apelację",
                                  status_note: "",
                                  id: client.id,
                                };

                                fetch(
                                  "https://apidevkppp.ftpeople.pl/setClientStatus",
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: secretKey,
                                    },
                                    body: JSON.stringify(body),
                                  }
                                )
                                  .then((response) => response.json())
                                  .then((data) => {
                                    return;
                                  })
                                  .catch((error) => {});
                              }

                              if (
                                taskMode === "c" &&
                                task === "Odpowiedź na apelację" &&
                                closedTask
                              ) {
                                var body = {
                                  status:
                                    "wygrana w I instancji - wpłynęła apelacja",
                                  status_note: "",
                                  id: client.id,
                                };

                                fetch(
                                  "https://apidevkppp.ftpeople.pl/setClientStatus",
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: secretKey,
                                    },
                                    body: JSON.stringify(body),
                                  }
                                )
                                  .then((response) => response.json())
                                  .then((data) => {
                                    return;
                                  })
                                  .catch((error) => {});
                              }

                              if (
                                taskMode === "c" &&
                                task === "Odpowiedź na wezwanie do zapłaty" &&
                                closedTask
                              ) {
                                var date_added3 =
                                  new Date().getFullYear() +
                                  "-" +
                                  (new Date().getMonth() + 1) +
                                  "-" +
                                  new Date().getDate() +
                                  " " +
                                  new Date().getHours() +
                                  ":" +
                                  new Date().getMinutes();
                                var date_start3 =
                                  new Date().getFullYear() +
                                  "-" +
                                  (new Date().getMonth() + 1) +
                                  "-" +
                                  new Date().getDate();
                                var dateFinal3 = new Date();

                                if (addWeeksTwo(new Date(date)) < new Date()) {
                                  var newFinalDate3 = new Date(
                                    new Date().setDate(new Date().getDate() + 1)
                                  );
                                } else {
                                  var newFinalDate3 = addWeeksTwo(
                                    new Date(date)
                                  );
                                }

                                if (newFinalDate3.getDay() === 0) {
                                  newFinalDate3 = new Date(
                                    newFinalDate3.setDate(
                                      newFinalDate3.getDate() + 1
                                    )
                                  );
                                }
                                if (newFinalDate3.getDay() === 6) {
                                  newFinalDate3 = new Date(
                                    newFinalDate3.setDate(
                                      newFinalDate3.getDate() + 2
                                    )
                                  );
                                }
                                dateFinal3 =
                                  newFinalDate3.getFullYear() +
                                  "-" +
                                  (newFinalDate3.getMonth() + 1) +
                                  "-" +
                                  newFinalDate3.getDate();

                                var body2 = {
                                  start_date: date_start3,
                                  final_date: dateFinal3,
                                  bank: client.bank,
                                  sygn: client.aSygn,
                                  group: groupX,
                                  cycle: cycle,
                                  responsible: responsible,
                                  client_name: client.petitioner,
                                  task: "Sprawdzenie czy klient wysłał podpisaną odpowiedź na wezwanie i potw. nadania oraz należy dodać dokumenty do Workflow",
                                  date_added: date_added3,
                                  user_added: "",
                                  status: "ZLECONE",
                                  court: client.aCourt,
                                  type: "POZASĄDOWE",
                                  readed: "no",
                                  clientId: client.id,
                                  task_conn: "c",
                                  team: taskMode === "n" ? nTeam : client.team,
                                };

                                await fetch(
                                  "https://apidevkppp.ftpeople.pl/insertTaskGroup",
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: secretKey,
                                    },
                                    body: JSON.stringify(body2),
                                  }
                                )
                                  .then((response) => response.json())
                                  .then((data) => {})
                                  .catch((error) => {});
                              }

                              if (
                                taskMode === "c" &&
                                (task === "Wezwanie do zapłaty" ||
                                  (client.type === "sankcja kredytu darmowego"
                                    ? task ===
                                      "Wezwanie do zapłaty z oświadczeniem"
                                    : false))
                              ) {
                                var body = {
                                  id: client.id,
                                  data_zasw: date,
                                };

                                fetch(
                                  "https://apidevkppp.ftpeople.pl/addDZClient",
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: secretKey,
                                    },
                                    body: JSON.stringify(body),
                                  }
                                )
                                  .then((response) => response.json())
                                  .then((data) => {
                                    return;
                                  })
                                  .catch((error) => {});

                                var date_added3 =
                                  new Date().getFullYear() +
                                  "-" +
                                  (new Date().getMonth() + 1) +
                                  "-" +
                                  new Date().getDate() +
                                  " " +
                                  new Date().getHours() +
                                  ":" +
                                  new Date().getMinutes();
                                var date_start3 =
                                  new Date().getFullYear() +
                                  "-" +
                                  (new Date().getMonth() + 1) +
                                  "-" +
                                  new Date().getDate();
                                var dateFinal3 = new Date();

                                if (addDay(new Date(date)) < new Date()) {
                                  var newFinalDate3 = new Date(
                                    new Date().setDate(new Date().getDate() + 1)
                                  );
                                } else {
                                  var newFinalDate3 = addDay(new Date(date));
                                }

                                if (newFinalDate3.getDay() === 0) {
                                  newFinalDate3 = new Date(
                                    newFinalDate3.setDate(
                                      newFinalDate3.getDate() + 1
                                    )
                                  );
                                }
                                if (newFinalDate3.getDay() === 6) {
                                  newFinalDate3 = new Date(
                                    newFinalDate3.setDate(
                                      newFinalDate3.getDate() + 2
                                    )
                                  );
                                }
                                dateFinal3 =
                                  newFinalDate3.getFullYear() +
                                  "-" +
                                  (newFinalDate3.getMonth() + 1) +
                                  "-" +
                                  newFinalDate3.getDate();

                                var body2 = {
                                  start_date: date_start3,
                                  final_date: dateFinal3,
                                  bank: client.bank,
                                  sygn: client.aSygn,
                                  responsible: getLawyerName(
                                    client.client_owner
                                  ),
                                  group: groupX,
                                  cycle: cycle,
                                  client_name: client.petitioner,
                                  task: "Za 7 dni upływa terminu do wysłania pozwu",
                                  date_added: date_added3,
                                  user_added: "",
                                  status: "ZLECONE",
                                  court: client.aCourt,
                                  type: "POZASĄDOWE",
                                  readed: "no",
                                  clientId: client.id,
                                  task_conn: "c",
                                  team: taskMode === "n" ? nTeam : client.team,
                                };

                                await fetch(
                                  "https://apidevkppp.ftpeople.pl/insertTaskGroup",
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: secretKey,
                                    },
                                    body: JSON.stringify(body2),
                                  }
                                )
                                  .then((response) => response.json())
                                  .then((data) => {})
                                  .catch((error) => {});

                                var body3 = {
                                  id: client.id,
                                  praw_wezw:
                                    props.user.role === "admin"
                                      ? responsible
                                      : props.user.name,
                                };

                                fetch(
                                  "https://apidevkppp.ftpeople.pl/addPWClient",
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: secretKey,
                                    },
                                    body: JSON.stringify(body3),
                                  }
                                )
                                  .then((response) => response.json())
                                  .then((data) => {
                                    return;
                                  })
                                  .catch((error) => {});

                                var body4 = {
                                  status:
                                    "mamy dokumenty - wezwanie do wysłania",
                                  status_note: "",
                                  id: client.id,
                                };

                                fetch(
                                  "https://apidevkppp.ftpeople.pl/setClientStatus",
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: secretKey,
                                    },
                                    body: JSON.stringify(body4),
                                  }
                                )
                                  .then((response) => response.json())
                                  .then((data) => {})
                                  .catch((error) => {});
                              }

                              if (
                                taskMode === "c" &&
                                task === "Sporządzenie pozwu"
                              ) {
                                var body3 = {
                                  id: client.id,
                                  praw_pozew:
                                    props.user.role === "admin"
                                      ? responsible
                                      : props.user.name,
                                };

                                fetch(
                                  "https://apidevkppp.ftpeople.pl/addPPClient",
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: secretKey,
                                    },
                                    body: JSON.stringify(body3),
                                  }
                                )
                                  .then((response) => response.json())
                                  .then((data) => {
                                    return;
                                  })
                                  .catch((error) => {});
                              }

                              if (isCyclic) {
                                var finalDate = new Date(final_date).setDate(
                                  new Date(final_date).getDate() + 90
                                );
                                switch (cyclePeriod) {
                                  case "7":
                                    finalDate = new Date(final_date).setDate(
                                      new Date(final_date).getDate() + 90
                                    );
                                    break;
                                  case "14":
                                    finalDate = new Date(final_date).setDate(
                                      new Date(final_date).getDate() + 90
                                    );
                                    break;
                                  case "28":
                                    finalDate = new Date(final_date).setDate(
                                      new Date(final_date).getDate() + 180
                                    );
                                    break;
                                  case "90":
                                    finalDate = new Date(final_date).setDate(
                                      new Date(final_date).getDate() + 365
                                    );
                                    break;
                                  default:
                                    break;
                                }

                                var cycle = +cyclePeriod;
                                var startDate = new Date(final_date);
                                while (
                                  new Date(startDate) <= new Date(finalDate)
                                ) {
                                  startDate = new Date(
                                    startDate.setDate(
                                      startDate.getDate() + cycle
                                    )
                                  );
                                  if (startDate.getDay() === 0) {
                                    startDate = new Date(
                                      startDate.setDate(startDate.getDate() + 1)
                                    );
                                  }
                                  if (startDate.getDay() === 6) {
                                    startDate = new Date(
                                      startDate.setDate(startDate.getDate() + 2)
                                    );
                                  }

                                  var body = {
                                    group: groupX,
                                    cycle: cycle,
                                    responsible:
                                      props.user.role === "admin"
                                        ? responsible
                                        : props.user.name,
                                    start_date: date,
                                    final_date:
                                      startDate.getFullYear() +
                                      "-" +
                                      (startDate.getMonth() + 1) +
                                      "-" +
                                      startDate.getDate(),
                                    bank: taskMode === "c" ? client.bank : bank,
                                    sygn:
                                      taskMode === "c"
                                        ? tType === "SĄDOWE"
                                          ? sygnA
                                          : ""
                                        : sygnA,
                                    client_name:
                                      taskMode === "c"
                                        ? client.petitioner
                                        : getClientName(),
                                    task: task,
                                    date_added: date_added,
                                    user_added: props.user.name,
                                    status: closedTask
                                      ? "WYKONANE"
                                      : props.user.role === "admin"
                                      ? responsible === ""
                                        ? "ZLECONE"
                                        : "ZLECONE"
                                      : "ZLECONE",
                                    court:
                                      taskMode === "c"
                                        ? tType === "SĄDOWE"
                                          ? court
                                          : ""
                                        : court,
                                    type: tType,
                                    addRole: props.userRole,
                                    readed: "no",
                                    cycleId: cycleId,
                                    clientId: taskMode === "c" ? client.id : "",
                                    task_conn: taskMode,
                                    team:
                                      taskMode === "n" ? nTeam : client.team,
                                    note: note,
                                  };

                                  await fetch(
                                    "https://apidevkppp.ftpeople.pl/insertTaskFullGroup",
                                    {
                                      method: "POST",
                                      headers: {
                                        "Content-Type": "application/json",
                                        Authorization: secretKey,
                                      },
                                      body: JSON.stringify(body),
                                    }
                                  )
                                    .then((response) => response.json())
                                    .then((data) => {})
                                    .catch((error) => {});
                                }
                              }
                              props.handleOptionChangeClose("calendar");
                              if (
                                taskMode === "c" ||
                                props.place === "client"
                              ) {
                                addClientSygn();
                              } else {
                                MySwal.fire({
                                  icon: "success",
                                  title: "Dodano",
                                  text: "nowe zadanie",
                                }).then((result) => {
                                  props.close();
                                });
                              }
                            }
                          });
                        });
                    });
                  } else {
                    if (taskMode === "c" && task === "Apelacja" && closedTask) {
                      var body = {
                        status: "przegrana w I instancji - wnieśliśmy apelację",
                        status_note: "",
                        id: client.id,
                      };

                      fetch("https://apidevkppp.ftpeople.pl/setClientStatus", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body),
                      })
                        .then((response) => response.json())
                        .then((data) => {
                          return;
                        })
                        .catch((error) => {});
                    }

                    if (
                      taskMode === "c" &&
                      task === "Odpowiedź na apelację" &&
                      closedTask
                    ) {
                      var body = {
                        status: "wygrana w I instancji - wpłynęła apelacja",
                        status_note: "",
                        id: client.id,
                      };

                      fetch("https://apidevkppp.ftpeople.pl/setClientStatus", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body),
                      })
                        .then((response) => response.json())
                        .then((data) => {
                          return;
                        })
                        .catch((error) => {});
                    }

                    if (
                      taskMode === "c" &&
                      task === "Odpowiedź na wezwanie do zapłaty" &&
                      closedTask
                    ) {
                      var date_added3 =
                        new Date().getFullYear() +
                        "-" +
                        (new Date().getMonth() + 1) +
                        "-" +
                        new Date().getDate() +
                        " " +
                        new Date().getHours() +
                        ":" +
                        new Date().getMinutes();
                      var date_start3 =
                        new Date().getFullYear() +
                        "-" +
                        (new Date().getMonth() + 1) +
                        "-" +
                        new Date().getDate();
                      var dateFinal3 = new Date();

                      if (addWeeksTwo(new Date(date)) < new Date()) {
                        var newFinalDate3 = new Date(
                          new Date().setDate(new Date().getDate() + 1)
                        );
                      } else {
                        var newFinalDate3 = addWeeksTwo(new Date(date));
                      }

                      if (newFinalDate3.getDay() === 0) {
                        newFinalDate3 = new Date(
                          newFinalDate3.setDate(newFinalDate3.getDate() + 1)
                        );
                      }
                      if (newFinalDate3.getDay() === 6) {
                        newFinalDate3 = new Date(
                          newFinalDate3.setDate(newFinalDate3.getDate() + 2)
                        );
                      }
                      dateFinal3 =
                        newFinalDate3.getFullYear() +
                        "-" +
                        (newFinalDate3.getMonth() + 1) +
                        "-" +
                        newFinalDate3.getDate();

                      var body2 = {
                        start_date: date_start3,
                        final_date: dateFinal3,
                        bank: client.bank,
                        sygn: client.aSygn,
                        responsible: responsible,
                        group: groupX,
                        cycle: cycle,
                        client_name: client.petitioner,
                        task: "Sprawdzenie czy klient wysłał podpisaną odpowiedź na wezwanie i potw. nadania oraz należy dodać dokumenty do Workflow",
                        date_added: date_added3,
                        user_added: "",
                        status: "ZLECONE",
                        court: client.aCourt,
                        type: "POZASĄDOWE",
                        readed: "no",
                        clientId: client.id,
                        task_conn: "c",
                        team: taskMode === "n" ? nTeam : client.team,
                      };

                      await fetch(
                        "https://apidevkppp.ftpeople.pl/insertTaskGroup",
                        {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: secretKey,
                          },
                          body: JSON.stringify(body2),
                        }
                      )
                        .then((response) => response.json())
                        .then((data) => {})
                        .catch((error) => {});
                    }

                    if (
                      taskMode === "c" &&
                      (task === "Wezwanie do zapłaty" ||
                        (client.type === "sankcja kredytu darmowego"
                          ? task === "Wezwanie do zapłaty z oświadczeniem"
                          : false))
                    ) {
                      var body = {
                        id: client.id,
                        data_zasw: date,
                      };

                      fetch("https://apidevkppp.ftpeople.pl/addDZClient", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body),
                      })
                        .then((response) => response.json())
                        .then((data) => {
                          return;
                        })
                        .catch((error) => {});

                      var date_added3 =
                        new Date().getFullYear() +
                        "-" +
                        (new Date().getMonth() + 1) +
                        "-" +
                        new Date().getDate() +
                        " " +
                        new Date().getHours() +
                        ":" +
                        new Date().getMinutes();
                      var date_start3 =
                        new Date().getFullYear() +
                        "-" +
                        (new Date().getMonth() + 1) +
                        "-" +
                        new Date().getDate();
                      var dateFinal3 = new Date();

                      if (addDay(new Date(date)) < new Date()) {
                        var newFinalDate3 = new Date(
                          new Date().setDate(new Date().getDate() + 1)
                        );
                      } else {
                        var newFinalDate3 = addDay(new Date(date));
                      }

                      if (newFinalDate3.getDay() === 0) {
                        newFinalDate3 = new Date(
                          newFinalDate3.setDate(newFinalDate3.getDate() + 1)
                        );
                      }
                      if (newFinalDate3.getDay() === 6) {
                        newFinalDate3 = new Date(
                          newFinalDate3.setDate(newFinalDate3.getDate() + 2)
                        );
                      }
                      dateFinal3 =
                        newFinalDate3.getFullYear() +
                        "-" +
                        (newFinalDate3.getMonth() + 1) +
                        "-" +
                        newFinalDate3.getDate();

                      var body2 = {
                        start_date: date_start3,
                        final_date: dateFinal3,
                        bank: client.bank,
                        sygn: client.aSygn,
                        responsible: getLawyerName(client.client_owner),
                        group: groupX,
                        cycle: cycle,
                        client_name: client.petitioner,
                        task: "Za 7 dni upływa terminu do wysłania pozwu",
                        date_added: date_added3,
                        user_added: "",
                        status: "ZLECONE",
                        court: client.aCourt,
                        type: "POZASĄDOWE",
                        readed: "no",
                        clientId: client.id,
                        task_conn: "c",
                        team: taskMode === "n" ? nTeam : client.team,
                      };

                      await fetch(
                        "https://apidevkppp.ftpeople.pl/insertTaskGroup",
                        {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: secretKey,
                          },
                          body: JSON.stringify(body2),
                        }
                      )
                        .then((response) => response.json())
                        .then((data) => {})
                        .catch((error) => {});

                      var body3 = {
                        id: client.id,
                        praw_wezw:
                          props.user.role === "admin"
                            ? responsible
                            : props.user.name,
                      };

                      fetch("https://apidevkppp.ftpeople.pl/addPWClient", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body3),
                      })
                        .then((response) => response.json())
                        .then((data) => {
                          return;
                        })
                        .catch((error) => {});

                      var body4 = {
                        status: "mamy dokumenty - wezwanie do wysłania",
                        status_note: "",
                        id: client.id,
                      };

                      fetch("https://apidevkppp.ftpeople.pl/setClientStatus", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body4),
                      })
                        .then((response) => response.json())
                        .then((data) => {})
                        .catch((error) => {});
                    }

                    if (taskMode === "c" && task === "Sporządzenie pozwu") {
                      var body3 = {
                        id: client.id,
                        praw_pozew:
                          props.user.role === "admin"
                            ? responsible
                            : props.user.name,
                      };

                      fetch("https://apidevkppp.ftpeople.pl/addPPClient", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body3),
                      })
                        .then((response) => response.json())
                        .then((data) => {
                          return;
                        })
                        .catch((error) => {});
                    }

                    if (isCyclic) {
                      var finalDate = new Date(final_date).setDate(
                        new Date(final_date).getDate() + 90
                      );
                      switch (cyclePeriod) {
                        case "7":
                          finalDate = new Date(final_date).setDate(
                            new Date(final_date).getDate() + 90
                          );
                          break;
                        case "14":
                          finalDate = new Date(final_date).setDate(
                            new Date(final_date).getDate() + 90
                          );
                          break;
                        case "28":
                          finalDate = new Date(final_date).setDate(
                            new Date(final_date).getDate() + 180
                          );
                          break;
                        case "90":
                          finalDate = new Date(final_date).setDate(
                            new Date(final_date).getDate() + 365
                          );
                          break;
                        default:
                          break;
                      }

                      var cycle = +cyclePeriod;
                      var startDate = new Date(final_date);
                      while (new Date(startDate) <= new Date(finalDate)) {
                        startDate = new Date(
                          startDate.setDate(startDate.getDate() + cycle)
                        );
                        if (startDate.getDay() === 0) {
                          startDate = new Date(
                            startDate.setDate(startDate.getDate() + 1)
                          );
                        }
                        if (startDate.getDay() === 6) {
                          startDate = new Date(
                            startDate.setDate(startDate.getDate() + 2)
                          );
                        }

                        var body = {
                          responsible:
                            props.user.role === "admin"
                              ? responsible
                              : props.user.name,
                          group: groupX,
                          cycle: cycle,
                          start_date: date,
                          final_date:
                            startDate.getFullYear() +
                            "-" +
                            (startDate.getMonth() + 1) +
                            "-" +
                            startDate.getDate(),
                          bank: taskMode === "c" ? client.bank : bank,
                          sygn:
                            taskMode === "c"
                              ? tType === "SĄDOWE"
                                ? sygnA
                                : ""
                              : sygnA,
                          client_name:
                            taskMode === "c"
                              ? client.petitioner
                              : getClientName(),
                          task: task,
                          date_added: date_added,
                          user_added: props.user.name,
                          status: closedTask
                            ? "WYKONANE"
                            : props.user.role === "admin"
                            ? responsible === ""
                              ? "ZLECONE"
                              : "ZLECONE"
                            : "ZLECONE",
                          court:
                            taskMode === "c"
                              ? tType === "SĄDOWE"
                                ? court
                                : ""
                              : court,
                          type: tType,
                          addRole: props.userRole,
                          readed: "no",
                          cycleId: cycleId,
                          clientId: taskMode === "c" ? client.id : "",
                          task_conn: taskMode,
                          team: taskMode === "n" ? nTeam : client.team,
                          note: note,
                        };

                        await fetch(
                          "https://apidevkppp.ftpeople.pl/insertTaskFullGroup",
                          {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              Authorization: secretKey,
                            },
                            body: JSON.stringify(body),
                          }
                        )
                          .then((response) => response.json())
                          .then((data) => {})
                          .catch((error) => {});
                      }
                    }
                    props.handleOptionChangeClose("calendar");
                    if (taskMode === "c" || props.place === "client") {
                      addClientSygn();
                    } else {
                      MySwal.fire({
                        icon: "success",
                        title: "Dodano",
                        text: "nowe zadanie",
                      }).then((result) => {
                        props.close();
                      });
                    }
                  }
                })
                .catch((error) => {});
            } else {
              MySwal.fire({
                icon: "error",
                title: "Błąd",
                text: "Wypełnij wymagane pola formularza",
              }).then((result) => {
                setLoading(false);
              });
            }
          } else {
            MySwal.fire({
              icon: "error",
              title: "Błąd",
              text: "Pracownik przebywa w tym czasie na urlopie",
            }).then((result) => {
              setLoading(false);
            });
          }
        } else {
          MySwal.fire({
            icon: "error",
            title: "Błąd",
            text: "Data wykonania zadania musi nastąpić w przyszłości!",
          }).then((result) => {
            setLoading(false);
          });
        }
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Data wprowadzenia zadania musi nastąpić przed datą wykonania!",
        }).then((result) => {
          setLoading(false);
        });
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Data odebrania zadania nie może nastąpić w przyszłości!",
      }).then((result) => {
        setLoading(false);
      });
    }
  };

  const saveEditAccept = () => {
    if (!checkHoliday()) {
      saveEdit();
    } else {
      MySwal.fire({
        title:
          "Osoba, której chcesz przypisać zadanie jest w tym czasie na urlopie. Czy nadal chcesz przypisać?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Tak",
        denyButtonText: `Nie`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          saveEdit();
        } else if (result.isDenied) {
          return;
        }
      });
    }
  };

  const saveEdit = async (e) => {
    if (props.taskData.task === "Sprawdzenie pozwu") {
      var body = {
        id: props.taskData.clientId,
        praw_spr_pozew: responsible,
      };

      await fetch("https://apidevkppp.ftpeople.pl/addPSPClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});
    }

    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    if (
      new Date(final_date) >=
      new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      )
    ) {
      if (!checkFree(final_date)) {
        if (
          !checkHoliday(
            props.user.role === "admin" ? responsible : props.user.name,
            final_date
          )
        ) {
          if (validateForm()) {
            var body = {
              id: props.taskData.id,
              responsible:
                props.user.role === "admin" ? responsible : props.user.name,
              start_date: date,
              final_date: final_date,
              bank: bank,
              sygn: sygnA,
              client_name: getClientName(),
              task: task.replaceAll(" - SKD", ""),
              date_modified: date_added,
              user_modified: props.user.name,
              status: responsible === "" ? "ZLECONE" : "ZLECONE",
              court: court,
              type: tType,
              noteTask: note,
            };

            var bodyXX = {
              new: JSON.stringify(body),
              old: JSON.stringify(props.taskData),
              user: props.user.name,
              taskId: props.taskData.id,
            };

            fetch("https://apidevkppp.ftpeople.pl/addTaskHistory", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(bodyXX),
            })
              .then((response) => response.text())
              .then((data) => {});

            await fetch("https://apidevkppp.ftpeople.pl/editTask", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.text())
              .then((data) => {
                if (final_date !== final_date_ori) {
                  var body2 = {
                    id: props.taskData.id,
                    value: +props.taskData.count_rescheduling + 1,
                  };

                  fetch("https://apidevkppp.ftpeople.pl/addResTask", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: secretKey,
                    },
                    body: JSON.stringify(body2),
                  })
                    .then((response) => response.text())
                    .then((data) => {});
                }
                var length = uploadFilesArray.length;
                var progr = 0;
                if (length > 0) {
                  uploadFilesArray.map(async (file) => {
                    let formData = new FormData();
                    formData.append("file", file);
                    formData.append("type", "task");
                    formData.append(
                      "clientId",
                      taskMode === "c" ? props.taskData.clientId : ""
                    );
                    formData.append("taskId", props.taskData.id);
                    formData.append("user", props.user.name);

                    await fetch("https://apidevkppp.ftpeople.pl/uploadFile", {
                      method: "POST",
                      body: formData,
                    })
                      .then((response) => {
                        return response.text();
                      })
                      .then((responseJson) => {
                        ++progr;
                        MySwal.fire({
                          icon: "success",
                          title: "Wysłano plik: " + progr + "/" + length,
                          text: "",
                        }).then(async (result) => {
                          if (progr === length) {
                            MySwal.fire({
                              icon: "success",
                              title: "Edytowano",
                              text: "zadanie",
                            }).then((result) => {
                              props.close();
                            });
                            props.close();
                          }
                        });
                      });
                  });
                } else {
                  MySwal.fire({
                    icon: "success",
                    title: "Edytowano",
                    text: "zadanie",
                  }).then((result) => {
                    props.close();
                  });
                  props.close();
                }
              })
              .catch((error) => {});
          } else {
            MySwal.fire({
              icon: "error",
              title: "Błąd",
              text: "Wypełnij wymagane pola formularza",
            });
          }
        } else {
          MySwal.fire({
            title:
              "Osoba, której chcesz przypisać zadanie jest w tym czasie na urlopie. Czy nadal chcesz jej przypisać zadanie?",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Tak",
            denyButtonText: `Nie`,
          }).then(async (result) => {
            if (result.isConfirmed) {
              if (validateForm()) {
                var body = {
                  id: props.taskData.id,
                  responsible:
                    props.user.role === "admin" ? responsible : props.user.name,
                  start_date: date,
                  final_date: final_date,
                  bank: bank,
                  sygn: sygnA,
                  client_name: getClientName(),
                  task: task,
                  date_modified: date_added,
                  user_modified: props.user.name,
                  status: responsible === "" ? "ZLECONE" : "ZLECONE",
                  court: court,
                  type: tType,
                  noteTask: note,
                };

                await fetch("https://apidevkppp.ftpeople.pl/editTask", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: secretKey,
                  },
                  body: JSON.stringify(body),
                })
                  .then((response) => response.text())
                  .then((data) => {
                    if (final_date !== final_date_ori) {
                      var body2 = {
                        id: props.taskData.id,
                        value: +props.taskData.count_rescheduling + 1,
                      };

                      fetch("https://apidevkppp.ftpeople.pl/addResTask", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body2),
                      })
                        .then((response) => response.text())
                        .then((data) => {});
                    }
                    var length = uploadFilesArray.length;
                    var progr = 0;
                    if (length > 0) {
                      uploadFilesArray.map(async (file) => {
                        let formData = new FormData();
                        formData.append("file", file);
                        formData.append("type", "task");
                        formData.append(
                          "clientId",
                          taskMode === "c" ? props.taskData.clientId : ""
                        );
                        formData.append("taskId", props.taskData.id);
                        formData.append("user", props.user.name);

                        await fetch(
                          "https://apidevkppp.ftpeople.pl/uploadFile",
                          {
                            method: "POST",
                            body: formData,
                          }
                        )
                          .then((response) => {
                            return response.text();
                          })
                          .then((responseJson) => {
                            ++progr;
                            MySwal.fire({
                              icon: "success",
                              title: "Wysłano plik: " + progr + "/" + length,
                              text: "",
                            }).then(async (result) => {
                              if (progr === length) {
                                MySwal.fire({
                                  icon: "success",
                                  title: "Edytowano",
                                  text: "zadanie",
                                }).then((result) => {
                                  props.close();
                                });
                                props.close();
                              }
                            });
                          });
                      });
                    } else {
                      MySwal.fire({
                        icon: "success",
                        title: "Edytowano",
                        text: "zadanie",
                      }).then((result) => {
                        props.close();
                      });
                      props.close();
                    }
                  })
                  .catch((error) => {});
              } else {
                MySwal.fire({
                  icon: "error",
                  title: "Błąd",
                  text: "Wypełnij wymagane pola formularza",
                });
              }
            } else if (result.isDenied) {
            }
          });
        }
      } else {
        MySwal.fire({
          title:
            "W dniu wykonania zadania przypada dzień wolny. Czy nadal chcesz dodać zadanie?",
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: "Tak",
          denyButtonText: `Nie`,
        }).then(async (result) => {
          if (result.isConfirmed) {
            if (validateForm()) {
              var body = {
                id: props.taskData.id,
                responsible:
                  props.user.role === "admin" ? responsible : props.user.name,
                start_date: date,
                final_date: final_date,
                bank: bank,
                sygn: sygnA,
                client_name: getClientName(),
                task: task,
                date_modified: date_added,
                user_modified: props.user.name,
                status: responsible === "" ? "ZLECONE" : "ZLECONE",
                court: court,
                type: tType,
                noteTask: note,
              };

              await fetch("https://apidevkppp.ftpeople.pl/editTask", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: secretKey,
                },
                body: JSON.stringify(body),
              })
                .then((response) => response.text())
                .then((data) => {
                  if (final_date !== final_date_ori) {
                    var body2 = {
                      id: props.taskData.id,
                      value: +props.taskData.count_rescheduling + 1,
                    };

                    fetch("https://apidevkppp.ftpeople.pl/addResTask", {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: secretKey,
                      },
                      body: JSON.stringify(body2),
                    })
                      .then((response) => response.text())
                      .then((data) => {});
                  }
                  var length = uploadFilesArray.length;
                  var progr = 0;
                  if (length > 0) {
                    uploadFilesArray.map(async (file) => {
                      let formData = new FormData();
                      formData.append("file", file);
                      formData.append("type", "task");
                      formData.append(
                        "clientId",
                        taskMode === "c" ? props.taskData.clientId : ""
                      );
                      formData.append("taskId", props.taskData.id);
                      formData.append("user", props.user.name);

                      await fetch("https://apidevkppp.ftpeople.pl/uploadFile", {
                        method: "POST",
                        body: formData,
                      })
                        .then((response) => {
                          return response.text();
                        })
                        .then((responseJson) => {
                          ++progr;
                          MySwal.fire({
                            icon: "success",
                            title: "Wysłano plik: " + progr + "/" + length,
                            text: "",
                          }).then(async (result) => {
                            if (progr === length) {
                              MySwal.fire({
                                icon: "success",
                                title: "Edytowano",
                                text: "zadanie",
                              }).then((result) => {
                                props.close();
                              });
                              props.close();
                            }
                          });
                        });
                    });
                  } else {
                    MySwal.fire({
                      icon: "success",
                      title: "Edytowano",
                      text: "zadanie",
                    }).then((result) => {
                      props.close();
                    });
                    props.close();
                  }
                })
                .catch((error) => {});
            } else {
              MySwal.fire({
                icon: "error",
                title: "Błąd",
                text: "Wypełnij wymagane pola formularza",
              });
            }
          } else if (result.isDenied) {
          }
        });
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Data wykonania zadania musi nastąpić w przyszłości!",
      });
    }
  };

  const checkHoliday = () => {
    var blocks = holidays.filter(
      (el) =>
        el.user ===
        (props.user.role === "admin" ? responsible : props.user.name)
    );
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      blocks.map((el) => {
        if (
          (el.date_from >= final_date && el.date_from <= final_date) ||
          (final_date >= el.date_from && final_date <= el.date_to)
        ) {
          bool = true;
        }
      });
    }
    return bool;
  };

  const createTaskTypesOptions = () => {
    var taskTypesOptions = [];
    getTaskTypesForTeam().map((el) => {
      taskTypesOptions.push({ label: el.name, value: el.name });
    });
    return taskTypesOptions;
  };

  const createBankOptions = () => {
    var banksOptions = [];
    getBanksForTeam().map((el) => {
      banksOptions.push({ label: el.name, value: el.name });
    });
    return banksOptions;
  };

  const createLawyersOptions = () => {
    var banksOptions = [];
    getUsersForTeam().map((el) => {
      banksOptions.push({ label: el.name, value: el.name });
    });
    return banksOptions;
  };

  const createCourtOptions = () => {
    var courtsOptions = [];
    getCourtsForTeam().map((el) => {
      courtsOptions.push({ label: el.name, value: el.name });
    });
    return courtsOptions;
  };

  const validateForm = () => {
    if (
      (taskMode === "c" && props.mode !== "edit"
        ? client.length === 0
        : clientsE.length === 0) ||
      date === "" ||
      task === "" ||
      final_date === "" ||
      (tType === "SĄDOWE" ? court === "" : false)
    ) {
      return false;
    } else {
      return true;
    }
  };

  const getUsersForTeam = (e) => {
    var usersForTeam = [];

    props.usersData.map((el) => {
      if (props.team === 0) {
        usersForTeam.push(el);
      } else if (el.team.includes(props.team)) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  const getBanksForTeam = (e) => {
    var usersForTeam = [];

    props.banksData.map((el) => {
      if (
        el.team
          .split(",")
          .filter((el2) =>
            props.team === 0 ? +el2 === 1 || +el2 === 2 : +el2 === props.team
          ).length > 0
      ) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  const getCourtsForTeam = (e) => {
    var usersForTeam = [];

    props.courtsData.map((el) => {
      if (
        el.team
          .split(",")
          .filter((el2) =>
            props.team === 0 ? +el2 === 1 || +el2 === 2 : +el2 === props.team
          ).length > 0
      ) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  const getTaskTypesForTeam = (e) => {
    var usersForTeam = [];

    props.tasksTypesData.map((el) => {
      if (
        el.team
          .split(",")
          .filter((el2) =>
            props.team === 0 ? +el2 === 1 || +el2 === 2 : +el2 === +props.team
          ).length > 0
      ) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  const handleClientChange = (e) => {
    setClientId(e.value);
    setClient(clients.filter((el) => +el.id === +e.value)[0]);
    setCourtOri(
      clients.filter((el) => el.id === e.value)[0].aCourt === "brak danych"
        ? ""
        : clients.filter((el) => el.id === e.value)[0].aCourt
    );
    setSygnAOri(
      clients.filter((el) => el.id === e.value)[0].aSygn === "brak danych"
        ? ""
        : clients.filter((el) => el.id === e.value)[0].aSygn
    );
    setCourt(
      clients.filter((el) => el.id === e.value)[0].aCourt === "brak danych"
        ? ""
        : clients.filter((el) => el.id === e.value)[0].aCourt
    );
    setSygnA(
      clients.filter((el) => el.id === e.value)[0].aSygn === "brak danych"
        ? ""
        : clients.filter((el) => el.id === e.value)[0].aSygn
    );
  };

  const getActualSygnForClient = (clientId) => {
    var sygns = clientsSygn.filter((el) => +el.clientId === +clientId);
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    return sygns.length > 0
      ? sygns[0].sygn !== ""
        ? sygns[0].sygn
        : "brak danych"
      : "brak danych";
  };

  const getActualCourtForClient = (clientId) => {
    var sygns = clientsSygn.filter((el) => +el.clientId === +clientId);
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    return sygns.length > 0
      ? sygns[0].court !== ""
        ? sygns[0].court
        : "brak danych"
      : "brak danych";
  };

  const taskModeC = (e) => {
    setTaskMode("c");
  };

  const taskModeN = (e) => {
    setTaskMode("n");
  };

  const changeFileName = (e) => {
    if (inputs[e.target.value] === "" || inputs[e.target.value] === undefined) {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    } else {
      var name = inputs[e.target.value];
      var newFile = new File(
        [uploadFilesArray[e.target.value]],
        name + "." + uploadFilesArray[e.target.value].name.split(".")[1],
        {
          type: uploadFilesArray[e.target.value].type,
        }
      );

      var arr = uploadFilesArray.filter(
        (el, index) => index !== +e.target.value
      );
      arr.push(newFile);

      setUploadFilesArray(arr);
      inputs[e.target.value] = "";
    }
  };

  const deleteTempFile = (e) => {
    var arr = uploadFilesArray.filter((el, index) => index !== +e.target.value);

    setUploadFilesArray(arr);
  };

  const createClientsOptions = (data) => {
    var bankOptions = [];
    data.map((el) => {
      bankOptions.push({
        label:
          el.petitioner +
          " | " +
          (data.filter((el2) => el2.id === el.id)[0].aSygn === "brak danych"
            ? el.credit_value
            : data.filter((el2) => el2.id === el.id)[0].aSygn),
        value: el.id,
      });
    });

    return bankOptions;
  };

  const documents = (
    <>
      <div style={{ marginTop: "3vh" }}></div>
      <input multiple={true} type="file" onChange={changeFiles} />

      {uploadFilesArray.length > 0 ? (
        <>
          <table
            style={{ width: "80%" }}
            id="detailClientTable"
            className="clients_table"
          >
            <tr>
              <th>Nazwa pliku</th>
              <th>Plik</th>
              <th></th>
            </tr>
            {uploadFilesArray.length > 0
              ? uploadFilesArray.map((el, index) => (
                  <>
                    <tr>
                      <td
                        style={{
                          width: "50%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        <div style={{ display: "flex", gap: "10px" }}>
                          <input
                            id={"fn" + index}
                            name={"fn" + index}
                            style={{ height: "2vh", marginTop: "0" }}
                            type="text"
                            value={inputs[index]}
                            onChange={(e) =>
                              setInputs((prev) => {
                                return { ...prev, [index]: e.target.value };
                              })
                            }
                          />
                          <button
                            className="refreshButton"
                            value={index}
                            onClick={changeFileName}
                          >
                            zmień
                          </button>
                        </div>
                      </td>
                      <td
                        style={{
                          textAlign: "left",
                          width: "40%",
                          padding: "5px 20px",
                          height: "3vh",
                          wordWrap: "anywhere",
                        }}
                      >
                        {el.name}
                      </td>
                      <td
                        style={{
                          textAlign: "left",
                          width: "10%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        <button
                          className="refreshButton"
                          value={index}
                          onClick={deleteTempFile}
                        >
                          usuń
                        </button>
                      </td>
                    </tr>
                  </>
                ))
              : ""}
          </table>
        </>
      ) : (
        ""
      )}
    </>
  );

  const closeAddSygn = () => {
    setShowAddSygnPopUp(false);
    props.handleOptionChangeClose("calendar");
    MySwal.fire({
      icon: "success",
      title: "Dodano",
      text: "nowe zadanie",
    }).then((result) => {
      props.close();
    });
  };

  const filterOption = (option, inputValue) => {
    return option.value
      .toString()
      .toLowerCase()
      .includes(inputValue.toString().toLowerCase());
  };

  return (
    <>
      <div className="mainContainerAddDate">
        {showAddSygnPopUp ? (
          <AddClientSygnPopup
            close={closeAddSygn}
            refreshData={props.refreshData}
            clientsSygnData={clientsSygn}
            clientsSygnSheetData={props.clientsSygnSheetData}
            user={props.user.name}
            clientId={client.id}
            logClientAction={props.logClientAction}
            client={client}
            courtsData={props.courtsData}
            place={"task"}
          />
        ) : (
          ""
        )}
        {loading ? (
          <LoadingPopup />
        ) : (
          <>
            <div style={{ width: "100%" }} className="closeBox">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            <div className="inputContainer">
              <div className="inputBox">
                <div style={{ width: "100%" }} className="checkBox">
                  <input
                    style={{ width: "2%" }}
                    id="checkCal5"
                    type="checkbox"
                    checked={closedTask}
                    onChange={handleIsClosedChange}
                  />
                  ZADANIE UKOŃCZONE
                </div>
              </div>

              {props.modeAdd === "main" ? (
                <>
                  <form
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1vw",
                    }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center" }}
                      className="radio"
                    >
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <input
                          style={{
                            boxShadow: "none",
                            width: "15px",
                            marginTop: "0",
                          }}
                          type="radio"
                          value="option1"
                          checked={taskMode === "c" ? true : false}
                          onChange={taskModeC}
                        />
                        Zadanie powiązane
                      </label>
                    </div>
                    <div
                      style={{ display: "flex", alignItems: "center" }}
                      className="radio"
                    >
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <input
                          style={{
                            boxShadow: "none",
                            width: "15px",
                            marginTop: "0",
                          }}
                          type="radio"
                          value="option1"
                          checked={taskMode === "n" ? true : false}
                          onChange={taskModeN}
                        />
                        Zadanie niepowiązane
                      </label>
                    </div>
                  </form>
                </>
              ) : (
                ""
              )}

              {props.place === "client" ? (
                <>
                  <span
                    style={{
                      fontSize: "1.5vw",
                      textTransform: "uppercase",
                      fontWeight: "900",
                    }}
                  >
                    Klient: {client.petitioner}{" "}
                    {props.team === 0 ? "- zespół " + client.team : ""}
                  </span>
                </>
              ) : (
                ""
              )}

              {props.modeAdd === "main" && taskMode === "c" ? (
                <>
                  <div style={{ width: "66%" }} className="inputBox">
                    <div className="inputCol_1">
                      <label>
                        Klient <span className="requiredStar">*</span>
                      </label>
                      <Select
                        noOptionsMessage={() => "Brak danych"}
                        placeholder={"Wybierz..."}
                        isClearable={false}
                        options={clientsOptions}
                        onChange={handleClientChange}
                      />
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}

              {props.modeAdd === "main" && taskMode === "n" ? (
                <>
                  {props.team === 0 ? (
                    <>
                      <div className="inputBox">
                        <div className="inputCol_2">
                          <label>
                            Zespół <span className="requiredStar">*</span>
                          </label>
                          <select
                            type="text"
                            id="court"
                            name="court"
                            value={nTeam}
                            onChange={(e) => setNTeam(e.target.value)}
                          >
                            <option key={0} value="1">
                              1
                            </option>
                            <option key={1} value="2">
                              2
                            </option>
                          </select>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  <div className="inputBox">
                    <div id="col1AddUser" className="inputCol_2">
                      <label>
                        Imię i nazwisko klienta{" "}
                        <span className="requiredStar">*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={name}
                        onChange={handleNameChange}
                      />
                    </div>
                    <div id="col2AddUser" className="inputCol_2">
                      <button
                        id="addButton"
                        className="acceptButton"
                        value={name}
                        onClick={handleAddClient}
                      >
                        DODAJ
                      </button>
                    </div>
                  </div>

                  {clientsE.length > 0 ? (
                    <div className="colClient">
                      {clientsE.map((el) => (
                        <>
                          <div className="rowClient">
                            <div className="rowClient_col1">{el.name}</div>
                            <div className="rowClient_col2">
                              <button
                                id="addButton"
                                className="acceptButton"
                                value={el.id}
                                onClick={handleDeleteClient}
                              >
                                USUŃ
                              </button>
                            </div>
                          </div>
                        </>
                      ))}
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}

              {props.mode === "edit" && props.user.role === "user" ? (
                ""
              ) : (
                <div className="inputBox">
                  <div className="inputCol_3">
                    <label>Rodzaj zadania</label>
                    <select
                      type="text"
                      id="court"
                      name="court"
                      value={tType}
                      onChange={handleTTypeChange}
                    >
                      <option key={0} value="SĄDOWE">
                        SĄDOWE
                      </option>
                      <option key={1} value="POZASĄDOWE">
                        POZASĄDOWE
                      </option>
                    </select>
                  </div>
                </div>
              )}
              {props.mode === "edit" &&
              props.user.role === "user" &&
              props.taskData.addRole === "admin" ? (
                ""
              ) : (
                <>
                  <div className="inputBox">
                    {!closedTask ? (
                      <>
                        <div className="inputCol_3">
                          <label>
                            Data odebrania
                            <span className="requiredStar">*</span>
                          </label>
                          <input
                            type="date"
                            id="date"
                            name="date"
                            value={date}
                            onChange={handleDateChange}
                            min="2002-01-01"
                          />
                        </div>
                        <div className="inputCol_3">
                          <label>
                            Data realizacji{" "}
                            <span className="requiredStar">*</span>
                          </label>
                          <input
                            type="date"
                            id="date"
                            name="date"
                            value={final_date}
                            onChange={handleFinalDateChange}
                            min="2002-01-01"
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    <div className="inputCol_3">
                      <label>
                        Zadanie <span className="requiredStar">*</span>
                      </label>
                      <Select
                        onFocus={() => ""}
                        noOptionsMessage={() => "Brak danych"}
                        placeholder={"Wybierz..."}
                        isClearable={false}
                        value={{ value: task, label: task }}
                        options={taskTypesOptions}
                        onChange={handleTaskChange}
                      />
                    </div>
                  </div>
                  {taskMode === "n" ? (
                    <>
                      <div className="inputBox">
                        <div className="inputCol_3">
                          <label>
                            {props.team === 2 ? "Przeciwnik procesowy" : "Bank"}{" "}
                            <span className="requiredStar">*</span>
                          </label>
                          <Select
                            noOptionsMessage={() => "Brak danych"}
                            placeholder={"Wybierz..."}
                            isClearable={false}
                            options={banksOptions}
                            onChange={handleBankChange}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {tType === "SĄDOWE" ? (
                    <>
                      <div className="inputBox">
                        <div className="inputCol_3">
                          <label>
                            Sąd<span className="requiredStar">*</span>
                          </label>
                          <Select
                            noOptionsMessage={() => "Brak danych"}
                            placeholder={"Wybierz..."}
                            isClearable={false}
                            options={courtOptions}
                            defaultValue={{ label: court, value: court }}
                            value={{ label: court, value: court }}
                            onChange={handleCourtChange}
                          />
                        </div>
                        <div className="inputCol_3">
                          <label>Sygnatura</label>
                          <input
                            type="text"
                            id="signature"
                            name="signature"
                            value={sygnA}
                            onChange={handleSygnChange}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  <div className="inputBox">
                    <div className="inputCol_3">
                      {props.checkPermissions("zadaniePrzypisanieUsera") ||
                      props.user.role === "admin" ? (
                        <>
                          <label>Osoba odpowiedzialna</label>
                          {props.checkPermissions("przypisanieGrupDoZadan") &&
                          taskTypes.filter((e) => e.name === task && e.groupX)
                            .length > 0 ? (
                            <>
                              {" "}
                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <span
                                  style={{
                                    fontWeight: "300",
                                    fontSize: ".8vw",
                                  }}
                                >
                                  rodzaj odpowiedzialności
                                </span>
                                <Select
                                  noOptionsMessage={() => "Brak danych"}
                                  placeholder={"Wybierz..."}
                                  isClearable={false}
                                  value={{
                                    value: respOption,
                                    label:
                                      respOption === "person"
                                        ? "Osoba"
                                        : "Grupa",
                                  }}
                                  options={[
                                    { value: "person", label: "Osoba" },
                                    { value: "group", label: "Grupa" },
                                  ]}
                                  onChange={(e) => {
                                    setRespOption(e.value);
                                  }}
                                />
                              </div>
                            </>
                          ) : (
                            ""
                          )}

                          {respOption === "person" ? (
                            <Select
                              noOptionsMessage={() => "Brak danych"}
                              placeholder={"Wybierz..."}
                              isClearable={false}
                              value={{ value: responsible, label: responsible }}
                              options={lawyersOptions}
                              onChange={handleResponsibleChange}
                            />
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </>
              )}

              <div className="inputBox">
                <div className="inputCol_1">
                  <label>Notatka</label>
                  <textarea
                    spellCheck="false"
                    className="textAreaNote"
                    type="text"
                    id="url"
                    name="url"
                    value={note}
                    onChange={handleNoteChange}
                  />
                </div>
              </div>

              {documents}

              {props.mode === "edit" ? (
                ""
              ) : (
                <>
                  <div className="inputBox">
                    <div className="checkBox">
                      <input
                        id="checkCal5"
                        type="checkbox"
                        checked={isCyclic}
                        onChange={handleIsCyclicChange}
                      />
                      ZADANIE CYKLICZNE
                    </div>
                  </div>
                  {isCyclic ? (
                    <div className="inputBox">
                      <div className="inputCol_2">
                        <label>Powtarzalność cyklu</label>
                        <select
                          type="text"
                          id="court"
                          name="court"
                          value={cyclePeriod}
                          onChange={handleCyclePeriodChange}
                        >
                          <option key={0} value="7">
                            co 7 dni (okres powtarzalności cyklu: 3 miesiące)
                          </option>
                          <option key={1} value="14">
                            co 14 dni (okres powtarzalności cyklu: 3 miesiące)
                          </option>
                          <option key={2} value="28">
                            co 28 dni (okres powtarzalności cyklu: 6 miesiący)
                          </option>
                          <option key={3} value="90">
                            co 3 miesiące (okres powtarzalności cyklu: 12
                            miesięcy)
                          </option>
                        </select>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </>
              )}
            </div>
            <div className="acceptButtonContainer">
              <button
                className="acceptButton"
                onClick={props.mode === "edit" ? saveEdit : addTaskAccept}
              >
                {props.mode === "edit" ? "ZAPISZ" : "DODAJ ZADANIE"}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddTask;
